// extracted by mini-css-extract-plugin
export var header_top = "styles-module--header_top--3fQJ1";
export var header_top_title = "styles-module--header_top_title---FelW";
export var header_title = "styles-module--header_title--2G5Wm";